<template>
  <div class="tkCmp full-height linear-main3">
    <ld-header
      @click-left="$router.push({path:'/tk/tkQuery'})"
      :transparent="true"
      :white="true"
      :title="$t('A127','预订完成')"
    />
    <div class="pad-8" style="height: calc(100vh - 96px);">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <travel-tips :city-id="tkSearchInfo.arrport.cityId" />
        <!--  -->
        <div
          class="pad-b-5"
          v-for="(info,tkcmpindex) in flights"
          :key="tkcmpindex"
        >
          <div style="display: flex;justify-content: space-between;align-items: center;">
            <div class="pad-b-20 white">
              <div class="font24 font-lg pad-b-5">
                <ld-icon
                  :type="info.realOrderStatus!=1&&info.isShowApproval ? 'iconshenpi1' :
                    detail.isShowPay == 1 ? 'iconzhifu' :
                    'icondingzuoshj-icon-Reser'"
                  size="30"
                  class="order-status__icon"
                />
                {{ info.orderStatusRemark }}
              </div>
              <p v-show="info.realOrderStatus==1">
                {{ $t('C417','特别提示') }}！
              </p>
              <p v-show="info.realOrderStatus==1">
                您本次预订占座未成功，需要向航空公司申请座位，请等待服务商回复。如有疑问，请致电服务商咨询!
              </p>
              <p
                class="pad-b-5"
                v-show="info.realOrderStatus!=1&&!info.isShowApproval"
              >
                订单已成功提交！
              </p>
              <p
                class="pad-b-5"
                v-show="info.realOrderStatus!=1&&info.isShowApproval"
              >
                预订成功，请及时送审!
              </p>
              <p
                class="pad-b-5"
                v-show="info.realOrderStatus!=1&&!info.isShowApproval"
              >
                出票情况以收到短信为准!
              </p>
            </div>
            <div
              class="daojishi"
              v-if="li"
            >
              <span
                style="color: #fff;"
                v-if="msg"
              >剩余:{{ msg }}</span>
            </div>
          </div>
          <div class="pad-b-5">
            <van-cell>
              {{ $t('F001','订单号') }}：{{ info.orderNo }}
              <van-tag
                type="warning"
                v-if="'' != info.productColor && 3 == info.productType"
                :color="info.productColor"
              >
                {{ info.productTag || '' }}
              </van-tag>
              <van-tag
                type="warning"
                v-else
              >
                {{ info.productTag }}
              </van-tag>
              <span
                class="fr main-color"
                @click="toDetail(info.id)"
              >{{ $t('B011','查看订单') }}</span>
            </van-cell>
          </div>
          <div class="pad-b-5">
            <voyage
              :flights="info.orderRangeBeanList"
              :show-rule="true"
              :show-cabin="true"
            />
          </div>
          <!-- 用车信息 -->
          <div class="pad-b-5">
            <tkcarorder
              v-if="vehicleOrders"
              :vehicleOrders="vehicleOrders"
            />
          </div>

          <van-cell>
            <!--          {{ $t('C001','乘机人') }}：{{ info.orderPsgBeanList|getName }}-->
            <traver
              :traveler-list="info.orderPsgBeanList"
              :disabled="true"
              :add-button="false"
              :title="$t('C001','乘机人')"
            />
          </van-cell>
        </div>
        <!--  -->
        <ld-button
          detault
          @click="$router.push({path:'/tk/tkQuery'})"
        >
          {{ $t('B012','继续预订') }}
        </ld-button>
        <div
          class="qrCodbox"
          v-show="airlineData.qrCodeUrl"
        >
          <img :src="airlineData.qrCodeUrl">
          <p>{{ airlineData.title }}</p>
        </div>
      </mescroll-vue>
    </div>

    <!--  -->
    <ld-tabbar
      ref="tabbar"
      :price-list="pricelistNew"
    >
      <van-row
        class="bg-white full-width pad-lr-10 shadow"
        type="flex"
        align="center"
        justify="space-between"
        style="width: 100%;"
      >
        <van-col span="10">
          <span class="font12 money-color">&yen; </span>
          <span class="font22 money-color"> {{ detail.totalPrice +(detail.bxPrice||0) }}</span>
          <span class="font10 gray"> {{ $t('E017','共') }}{{ this.detail.orderPsgBeanList.length }}人</span>
          &nbsp;
        </van-col>
        <van-col>
          <span
            class="font12 text-center"
            @click.stop="toggle('tabbar')"
          >
            <span>{{ $t('E006','明细') }}</span>
            <van-icon
              name="arrow-up"
              class="vertical-middle"
              size="14"
            />
          </span>
        </van-col>
        <!-- <van-col
          span="6"
          v-if="detail.isShowCancel"
        >
          <ld-button
            defaults
            size="md"
            @click="cancel(detail)"
          >
            取消
          </ld-button>
        </van-col> -->
        <van-col
          span="8"
          v-if="detail.isShowPay"
        >
          <ld-button
            main
            size="md"
            @click.stop="toPay(detail.id)"
          >
            立即支付
          </ld-button>
        </van-col>
        <van-col
          span="8"
          v-if="detail.isShowApproval"
        >
          <ld-button
            main
            size="md"
            @click="sendApproval(detail)"
          >
            立即送审
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!-- 支付 -->
    <!-- <ld-pay
      ref="pay"
      order-type="11001"
      :order-id="orderId"
    /> -->
  </div>
</template>

<script>
import ldHeader from 'Common/ldHeader'
import voyage from 'Components/tk/voyage'
import {Cell, Tag, CountDown, Toast, Dialog} from 'vant'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import { mapGetters } from 'vuex'
// import Bussiness from 'Utils/business'
import travelTips from 'Components/travelTips'
import traver from 'Components/tk/traver'
// import Bussiness from 'Utils/business'
import {getSysParameter, queryVipParameter} from 'Utils/publicApi'
import autoPay from 'Components/ldPay/AutoPay'
import MescrollVue from 'mescroll.js/mescroll.vue'
//用车信息
import tkcarorder from 'Components/transferinfo/tkcarorders.vue'
import { isGat, toPayForGat } from 'Utils/gattools';

export default {
  name: 'TkCmp',
  components: {
    ldHeader,
    ldButton,
    voyage,
    traver,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [CountDown.name]: CountDown,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    ldTabbar,
    travelTips,
    MescrollVue,
    tkcarorder
  },
  data() {
    return {
      down: {use: false},
      Passengers: [],
      li: true,
      creatime: '', // 开始时间
      daoTim: '',  // 倒计时时间
      msg: '',
      djs: '',
      time1: true,
      flights: [],//订单集合
      priceList: [],
      airlineData: {}, // 航司入会
      isAutoPay: false,
      phone: '',
      vehicleOrders:'',
      summary: {
        pickprice: '',//接机价格
        dropprice: '',//送机价格
        picknumber: 0,//接机数量
        dropnumber: 0,//送机数量
      }
    }
  },
  computed:{
    ...mapGetters({
      tkSearchInfo: 'tk/tkSearchInfo',
    }),
    showFirstProductTypeColor () {
      return this.$route.query.showFirstProductTypeColor
    },
    // return{
    // 	'msg': 'string',
    // 	'orderList': [
    // 		{
    // 			'orderId': '43db5fe4cb6945cf8715c13e08f8a6a7',
    // 			'orderNo': 'string',
    // 			'pnrNo': 'string',
    // 			'pnrStatus': 'string'
    // 		}
    // 	],
    // 	'priceFlag': 'string'
    // }
    orderId(){
      return this.$route.query.orderId
    },
    priceFlag(){
      return this.$route.query.priceFlag
    },
    detail(){
      return this.flights[0]||{orderPsgBeanList:[]}
    },
    pricelistNew () {
      let adts = []
      let chds = []
      let coupon = {}
      if (this.detail.orderPsgBeanList && this.detail.orderPsgBeanList.length > 0) {
        this.detail.orderPsgBeanList.forEach(p => {
          if (p.psgType === 1) {
            adts.push(p)
          } else if (p.psgType === 2) {
            chds.push(p)
          }
        })
      }
      // { name: this.$t('E505','保险'), price: cache.bxPrice, amount: `/ ${cache.orderPsgBeanList.length*cache.orderRangeBeanList.length}份`, unit:'',show:cache.bxPrice>0},
      if (this.detail.obtBookCoupon) {
        coupon = this.details.obtBookCoupon
      }
      const priceList = [
        {
          type: 'spliter',
          name: '-------- ' + this.$t('C115', '成人') + ' --------',
          price: null,
          amount: null,
          unit: '',
          show: adts.length > 0,
          hideYen: true
        }, {
          type: 'adtP',
          name: this.$t('C1150', '票面'),
          price: adts[0] && adts[0].salePrice,
          amount: adts.length,
          unit: '/' + this.$t('E113', '人'),
          show: adts.length > 0
        }, {
          type: 'adtCN',
          name: this.$t('E102', '机建'),
          price: adts[0] && adts[0].airportFee,
          amount: adts.length,
          unit: '/' + this.$t('E113', '人'),
          show: adts.length > 0
        }, {
          type: 'adtYQ',
          name: this.$t('E103', '燃油税'),
          price: adts[0] && adts[0].tax,
          amount: adts.length,
          unit: '/' + this.$t('E113', '人'),
          show: adts.length > 0
        },{
          type: 'chdFW',
          name: '服务费',
          price: adts[0] && adts[0].serviceFee,
          amount: adts.length,
          unit: '/人',
          show: adts.length > 0
        },
        {
          type: 'chdBX',
          name: this.$t('E505', '保险'),
          price:this.$route.query.crbx,
          amount: `/ ${adts.length}份`,
          unit: '',
          show: this.bxPrice > 0 && adts.length > 0
        },
        // { name: this.$t('E505','保险'), price: cache.bxPrice, amount: `/ ${cache.orderPsgBeanList.length*cache.orderRangeBeanList.length}份`, unit:'',show:cache.bxPrice>0},
        {
          type: 'spliter',
          name: '-------- ' + this.$t('C116', '儿童') + ' --------',
          price: null,
          amount: null,
          unit: '',
          show: chds.length > 0,
          hideYen: true
        }, {
          type: 'chdP',
          name: this.$t('C116', '儿童'),
          price: chds[0] && chds[0].salePrice,
          amount: chds.length,
          unit: this.$t('E113', '人'),
          show: chds.length > 0
        }, {
          type: 'chdCN',
          name: this.$t('E102', '机建'),
          price: 0,
          amount: chds.length,
          unit: '/' + this.$t('E113', '人'),
          show: chds.length > 0
        }, {
          type: 'chdYQ',
          name: this.$t('E103', '燃油税'),
          price: chds[0] && chds[0].tax,
          amount: chds.length,
          unit: '/' + this.$t('E113', '人'),
          show: chds.length > 0
        },
        {
          type: 'chdFW',
          name: '服务费',
          price: adts[0] && adts[0].serviceFee,
          amount:chds.length,
          unit: '/人',
          show: chds.length > 0
        },
        {
          type: 'chdBX',
          name: this.$t('E505','保险'),
          price: this.$route.query.ertbx,
          amount: `/ ${chds.length}份`,
          unit:'',
          show:this.bxPrice > 0 && chds.length > 0
        },
        // { name: this.$t('E505','保险'), price: this.detail.bxPrice, amount: `/ ${this.detail.orderPsgBeanList.length*this.detail.orderRangeBeanList.length}份`, unit:'',show:this.detail.bxPrice>0},
        {
          type: 'adtP',
          name: this.$t('E003', '优惠劵'),
          price: coupon && coupon.amount,
          amount: 1,
          unit: '',
          show: coupon.amount > 0
        },
        //接送机费用
        {
          type: 'spliter',
          name: '-------- ' + "接送机" + ' --------',
          price: null,
          amount: null,
          unit: '',
          show:  this.detail.vehicleOrders, //是否显示
          hideYen: true
        },
        {
          type: 'pick-up',
          name: '接机',
          price: this.summary.pickprice,
          amount: `${this.summary.picknumber}/辆`,
          unit: '',
          show:this.summary.pickprice, //是否显示
          hideYen: true
        },
        {
          type: 'drop-off',
          name: '送机',
          price: this.summary.dropprice,
          amount: `${this.summary.dropnumber}/辆`,
          unit: '',
          show: this.summary.dropprice, //是否显示
          hideYen: true
        },

      ]
      return priceList
    },
  },
  mounted() {

  },
  async created(){
    this.init()
    // 获取公司客服电话
    let {data = {}} = await this.$api['common/getSysParameter']({
      paramNo: '11605007'
    })
    if (data.value1) {
      this.phone = data.value1
    }
    queryVipParameter('1221').then(res => {
      if(res.value1 == 0){
        this.li = true
      }else{
        setTimeout(()=>{
          this.creatime= this.detail.bookDate   // 下单开始的时间
        },1000)
        this.daoTim =res.value1  // 过期时间  15分钟 或者30分钟
        setInterval(this.countdown, 1000)   // 调用倒计时
        res.value1 // 根据value1返回的分钟数 页面展示倒计时
      }
    })
    if(this.msg = ''){
      this.time1 = false
    }
  },
  updated() {

  },
  methods: {
    countdown(){
      this.creatime= this.detail.bookDate
      var _that = this
      if (typeof _that.creatime !== 'undefined') {
        // x已经定义
        var now=new Date(_that.creatime.replace(/-/g,'/'))  //处理开始时间    这个方法兼容大多数浏览器以及h5手机端
        var minutes=Number(_that.daoTim)  //处理输入的过期时间
        var end=now.setMinutes (now.getMinutes () + minutes) //计算最后时间
        var time_now =  new Date().getTime() //当前时间
        var msec =end - time_now   //最后时间-当前时间
        if(msec>0){
          let day = parseInt(msec / 1000 / 60 / 60 / 24)
          let hr = parseInt(msec / 1000 / 60 / 60 % 24)
          let min = parseInt(msec / 1000 / 60 % 60)
          let sec = parseInt(msec / 1000 % 60)
          day = day
          hr = hr > 9 ? hr : '0' + hr
          min = min > 9 ? min : '0' + min
          sec = sec > 9 ? sec : '0' + sec,
          this.msg =  min + '分' + sec + '秒'
        }else{
          clearInterval(tim)
          if(_that.min == '0' && _that.sec == '0')
          {
            this.li = true
          }else{
            this.li = false
          }
        }
        const that = this
        var tim=setTimeout(function () {
          that.countdown(_that.creatime,_that.daoTim)
        }, 1000)
      } else {
        // x未定义
        console.log('88')
      }

    },

    async init(){
      if(this.priceFlag==1){
        this.$dialog.alert({ message: '当前预订舱位价格发生变化，系统已自动修改订单，实际价格以订单价格为准!'})
      }
      await	this.getDetail(this.orderId)
    },
    getDetail(orderId){
      return new Promise(async (resolve, reject) => {
        this.$api['tkOrder/orderDetail']({
          id: orderId
        }).then(async res => {
          let cache = res.data || {}
          this.bxPrice = cache.bxPrice
          this.airline = cache.airline
          if (cache.vehicleOrders) {
            this.carorderdata(cache.vehicleOrders)
          }
          // this.vehicleOrders=cache.vehicleOrders
          cache.totalPrice = cache.totalPrice + this.summary.pickprice * this.summary.picknumber + this.summary.dropprice * this.summary.dropnumber
          this.getFindByAirline()
          this.flights.push(cache)
          if (cache.isShowPay === '1') {
            let payRes = await autoPay.initAutoPay(this.$api, '11001', cache.id)
            if (payRes.isSuccess) {
              this.toDetail(orderId)
            }
          }
          resolve(resolve)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getFindByAirline(){
      this.$api['tkOrder/findByAirline']({
        airline:this.airline
      }).then(res => {
        this.airlineData = res.data || {}
      }).catch(res =>{
        this.$toast(res.errMsg)
      })
    },
    cancel(detail){
      // Bussiness.toOrderCancel({orderType: '11001',id:detail.id})
    },
    sendApproval(detail){//审批
      this.$router.push({path:'/approval/Send',query:{orderId:detail.id,orderNo:detail.orderNo,orderType:detail.orderType}})
    },
    toPay(orderId) {//支付
      if (this.li == false) {
        Toast('订单已取消')
      } else {
        if (this.flights[0].vehicleOrders) {
          Dialog.alert({
            message: '机票和用车将分别下单，请至订单列表进行支付',
          }).then(() => {
            console.log("123456")
            this.$router.push({path: '/allorder', query: {findType: 2}})
          });
          return
        }
        this.orderId = orderId
        // 关爱通渠道
        if (isGat()) {
          return toPayForGat(orderId, '11001');
        }
        // this.toggle('pay')
        this.$router.push({path: '/pay/payment', query: {orderType: '11001', orderId: this.orderId}})
      }
    },
    toDetail(orderId) {//去详情
      this.$router.push({
        path: '/tk/tkOrderDetail',
        query: {orderId: orderId, crbx: this.$route.query.crbx, ertbx: this.$route.query.ertbx}
      })
    },
    toggle(name) {
      this.$refs[name].toggle()
    },
    carorderdata(info) {
      let carinfo = []
      let pick = 0
      let drop = 0
      //  this.summary={
      // 	pickprice:'',//接机价格
      // 	dropprice:'',//送机价格
      // 	picknumber:0,//接机数量
      // 	dropnumber:0,//送机数量
      //  }
      info.forEach(item => {
        if (item.orderType == 4) {//接机
          if (pick == 0) {
            carinfo.push(item)
            this.summary.pickprice = item.useVehicleFee
            pick += 1
          }
          this.summary.picknumber += 1
        }
        if (item.orderType == 5) {
          if (drop == 0) {
            carinfo.push(item)
            this.summary.dropprice = item.useVehicleFee
            drop += 1
          }
          this.summary.dropnumber += 1
        }
      })
      this.vehicleOrders = carinfo
    }


  },
  beforeDestroy(){
    // this.$store.commit('tk/CLEAR_ALL',{})
    clearInterval(this.tim)
    this.tim = null
  },
  filters:{
    getName(arr){
      let nameArr=arr.map(item=>{
        return item.psgName
      })
      return nameArr.join(',')
    }
  },
  watch: {
    flights(val) {

      if (val[0].orderStatus == 0) {
        if (this.flights[0].vehicleOrders) {
          Dialog.confirm({
            title: '温馨提示!',
            message: '您本次预订占座未成功，需要向航空公司申请座位，请等待服务商回复。如有疑问，请致电服务商咨询,' + ' ' + '服务商电话:' + this.phone + '用车已下单成功，请到列表页面支付',
            messageAlign: 'left',
            showCancelButton: true,
            dangerouslyUseHTMLString: true,
            confirmButtonText: '拨打电话',
            cancelButtonText: '已知晓'
          })
            .then(() => {
              // on confirm
              window.location.href = 'tel:' + this.phone
            })
            .catch(() => {
              // on cancel
            })
        }
        console.log('申请中')
        Dialog.confirm({
          title: '温馨提示!',
          message: '您本次预订占座未成功，需要向航空公司申请座位，请等待服务商回复。如有疑问，请致电服务商咨询,' + ' ' + '服务商电话:' + this.phone,
          messageAlign: 'left',
          showCancelButton: true,
          dangerouslyUseHTMLString: true,
          confirmButtonText: '拨打电话',
          cancelButtonText: '已知晓'
        })
          .then(() => {
            // on confirm
            window.location.href = 'tel:' + this.phone
          })
          .catch(() => {
            // on cancel
          })
      }
    }
  },
}
</script>

<style lang="less" scoped>
.pad-8{
  padding: 8px;
}
.pad-b-5{
  padding-bottom: 5px;
}
.pad-b-20{
  padding-bottom: 20px;
}
.pad-lr-10{
  padding: 0 10px;
}
.qrCodbox{
  margin-top: 5px;
  padding: 10px;
  width: 100%;
  height: auto;
  background: white;
  text-align:center;
  margin-bottom: 50px;
  img{
    width: 130px;
    height: 130px;
    margin: 20px 0;
    background: black;
  }
  p{
    font-weight: 900;
    font-size: 18px;
  }
}
.daojishi{
  width: 120px;
  height: 20px;
  line-height: 20px;
}
</style>
